import api from '../../api'

import {
    SET_APPRAISAL_CADASTERANNEXES
} from '../../constants'

const default_state = {
    cadasterannexes: {}
}
const state = default_state

const actions = {
    FETCH_APPRAISAL_CADASTERANNEXES: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_appraisal_cadasterannexes) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_APPRAISAL_CADASTERANNEXES, res)
            })
    },
    SET_APPRAISAL_CADASTERANNEXES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTERANNEXES, data)
    },
    UPLOAD_CADASTERANNEX_FILES: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.uploadImages(data).then(()=>{
             resolve()
            })
        })
    },
    UPDATE_APPRAISAL_CADASTERANNEXES: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.object,
                path: 'appraisal_cadasterannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then((res) => {
                resolve()

            })

        })
    },
}

const mutations = {
    [SET_APPRAISAL_CADASTERANNEXES] (state, data) {
        state.cadasterannexes = check_undefined(data)
    }
}

const getters = {
    appraisal_cadasterannexes: state => {
        return state.cadasterannexes
    }
}


function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/appraisal/appraisal_cadasterannexes.js